import React from 'react';
import { productTypes } from '../../../../utils/productHelpers';

/**
 * Funding Window Tooltip content
 * Shows different content for Fixed Rate Saver vs Fixed Rate Cash ISA
 * @param {{ productType?: string }} props
 */
const FundingWindowTooltip = ({ productType }) => {
    // ISA-specific tooltip
    if (productType === productTypes.FixedRateCashISA) {
        return (
            <>
                <h3 className="account__blended-tooltip-title">Time left to add funds</h3>
                <ul className="account__blended-tooltip-items">
                    <li className="account__blended-tooltip-item">
                        You have a limited time window to add funds to your Fixed Rate Cash ISA.
                    </li>
                    <li className="account__blended-tooltip-item">
                        Once this window closes, you won&apos;t be able to make any additional deposits for the current tax year.
                    </li>
                </ul>
            </>
        );
    }
    
    // Default (FRS) tooltip
    return (
        <>
            <h3 className="account__blended-tooltip-title">Why do I have limited time?</h3>
            <ul className="account__blended-tooltip-items">
                <li className="account__blended-tooltip-item">
                    Your funding window is the seven-day period during which you can make deposits into this account. 
                    You won&apos;t be able to make any withdrawals during this time, and when it ends you won&apos;t be able to deposit any more money.
                </li>
                <li className="account__blended-tooltip-item">
                    If you don&apos;t deposit the minimum £5,000 during this time, we&apos;ll close the account and return any money to your linked account for you.
                </li>
            </ul>
        </>
    );
};

export default FundingWindowTooltip;